let query = '';
let resetQuery: ReturnType<typeof setTimeout>;

export function keyboardNav({ key }: { key: string }) {
  query += key ?? '';
  clearTimeout(resetQuery);
  resetQuery = setTimeout(() => (query = ''), 500);

  (
    Array.from(
      document.querySelectorAll('.input-phone__country__list__item'),
    )?.find((item) =>
      (item as HTMLElement).innerText
        .toLowerCase()
        ?.startsWith(query.toLowerCase()),
    ) as HTMLElement
  )?.focus();
}
